import { zIndexs } from './Options';

// import XYZ from 'ol/source/XYZ.js';
import VectorTileLayer from 'ol/layer/VectorTile.js';
import VectorTileSource from 'ol/source/VectorTile.js';
import MVT from 'ol/format/MVT';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import { Fill, Text } from 'ol/style';

// Pipes layer
export const layer = new VectorTileLayer({
    name: 'layerPipesConditionAssessments',
    source: new VectorTileSource({
        format: new MVT(),
    }),
    zIndex: zIndexs.pipes,
    opacity: 0.8,
    style: (feature) => {
    const properties = feature.getProperties();
    const { width } = properties;

    const color = properties.cPca;
    const text = String(properties.vPca || '');

    return new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
      text: new Text({
        text: text, // getText(properties, pipesSource),
        fill: new Fill({ color: '#000000' }),
        stroke: new Stroke({ color: '#ffffff', width: 4 }),
        font: '12px Calibri,sans-serif',
        textAlign: 'center',
        placement: 'line',
        // overflow: true,
        // declutter: true,
        // declutterMode: 'obstacle',
        // repeat: 500
      })
    })
  },
});

export const setSource = (newSource, props) => {
    layer.setSource(newSource);
};

export const getLayers = () => {
  return [layer];
};

export const hasFeatures = () => {
    return false;
};

// Clean the layer
export const clear = () => {
};

export const getStyle = (feature, bSelected) => {
    return null;
};

export const getInfoTooltip = (feature) => {
    return null;
};

export const tooltipRender = (itemInfo, context) => {
    return null;
};
